export const CREATE_EDUCATION_SERIES_EVENT = "CREATE_EDUCATION_SERIES_EVENT"
export const CREATE_EDUCATION_SERIES_EVENT_SUCCESS = "CREATE_EDUCATION_SERIES_EVENT_SUCCESS"
export const CREATE_EDUCATION_SERIES_EVENT_FAIL = "CREATE_EDUCATION_SERIES_EVENT_FAIL"

export const GET_EDUCATION_SERIES_EVENT = "GET_EDUCATION_SERIES_EVENT"
export const GET_EDUCATION_SERIES_EVENT_SUCCESS = "GET_EDUCATION_SERIES_EVENT_SUCCESS"
export const GET_EDUCATION_SERIES_EVENT_FAIL = "GET_EDUCATION_SERIES_EVENT_FAIL"

export const GET_EDUCATION_SERIES_EVENT_DETAILS = "GET_EDUCATION_SERIES_EVENT_DETAILS"
export const GET_EDUCATION_SERIES_EVENT_DETAILS_SUCCESS = "GET_EDUCATION_SERIES_EVENT_DETAILS_SUCCESS"
export const GET_EDUCATION_SERIES_EVENT_DETAILS_FAIL = "GET_EDUCATION_SERIES_EVENT_DETAILS_FAIL"

export const UPDATE_EDUCATION_SERIES_EVENT = "UPDATE_EDUCATION_SERIES_EVENT"
export const UPDATE_EDUCATION_SERIES_EVENT_SUCCESS = "UPDATE_EDUCATION_SERIES_EVENT_SUCCESS"
export const UPDATE_EDUCATION_SERIES_EVENT_FAIL = "UPDATE_EDUCATION_SERIES_EVENT_FAIL"

export const GET_EDUCATION_SERIES_EVENT_REPORT_PARTICIPANTS = "GET_EDUCATION_SERIES_EVENT_REPORT_PARTICIPANTS"
export const GET_EDUCATION_SERIES_EVENT_REPORT_PARTICIPANTS_SUCCESS = "GET_EDUCATION_SERIES_EVENT_REPORT_PARTICIPANTS_SUCCESS"
export const GET_EDUCATION_SERIES_EVENT_REPORT_PARTICIPANTS_FAIL = "GET_EDUCATION_SERIES_EVENT_REPORT_PARTICIPANTS_FAIL"